/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class QueryDefinitionModifierAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class QueryDefinitionModifierAPI {

		/**
		 * @function QueryDefinitionModifierAPI#modifyQueryDefinitionList
		 * @description modify the given query definitions, including global/tab filters, brushing and query hints
		 * @public
		 * @param {QueryDefinitionAPI[]} queryDefinitions
		 * @return {QueryDefinitionAPI[]} the modified queryDefinitions
		 */
		modifyQueryDefinitionList() {}

		/**
		 * @return {String} the type of the modifier
		 */
		getType(){}
	}
	return QueryDefinitionModifierAPI;
});
